import { TextInput } from '@consigli/facade';
import { FieldValues, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface IterationNameProps {
  validateName: (value: string) => boolean | string;
  label: string;
  errorMessage?: string;
  placeholder?: string;
}

export const IterationName = ({
  validateName,
  label,
  errorMessage,
  placeholder,
}: IterationNameProps) => {
  const { register, formState, resetField } = useFormContext<FieldValues>();
  const { errors } = formState;
  const { t } = useTranslation();

  return (
    <span className="mb-2 mt-2">
      <TextInput
        label={label}
        placeholder={placeholder}
        className="my-1 border border-day-secondary rounded"
        {...register('iterationName', {
          required: errorMessage,
          validate: validateName,
          maxLength: {
            value: 50,
            message: `${t('package-creation.too-long')}`,
          },
        })}
        onReset={() => resetField('iterationName')}
      />
      {errors.iterationName && (
        <div className="text-red-700 text-sm">{errors.iterationName?.message as string}</div>
      )}
    </span>
  );
};
